import {
  Button,
  CellphoneIcon,
  Col,
  colors,
  MonitorIcon,
  Text,
  Toggle,
  ToggleLink,
} from "@commonsku/styles";
import _ from "lodash";
import React from "react";
import { POPUP_TYPES } from "./helpers";

interface StorefrontHeaderProps {
  selectedLayoutThemeName: string;
  selectedThemeType: string;
  isLayoutUpdated: boolean;
  entityTemplateId: string;
  screenSize: string;
  setScreenSize: (size: string) => void;
  isMobileView: boolean;
  handleShowPopup: (showPopup: string, popUpConfig?: any) => void;
}

const StorefrontHeader: React.FC<StorefrontHeaderProps> = ({
  selectedLayoutThemeName,
  selectedThemeType,
  isLayoutUpdated,
  entityTemplateId,
  screenSize,
  setScreenSize,
  isMobileView,
  handleShowPopup,
}) => {
  return (
    <Col xs style={{ paddingBottom: 14 }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Text
          as="p"
          style={{
            color: "var(--color-neutrals-90)",
            fontFamily: "var(--font-family-bold)",
            fontSize: 24,
            marginBottom: 0,
            maxWidth: "40%",
          }}
        >
          {selectedLayoutThemeName || ""}{" "}
          {_.startCase(selectedThemeType.toLowerCase())}{" "}
          {isLayoutUpdated && `(edited)`}
        </Text>
        <Toggle size="medium" style={{ width: "auto" }}>
          <ToggleLink
            stretch
            selected={screenSize === "current"}
            onClick={() => setScreenSize("current")}
          >
            <MonitorIcon
              style={{ marginRight: 4 }}
              color={!isMobileView ? colors.white : colors.teal.main}
            />
            Desktop
          </ToggleLink>
          <ToggleLink
            stretch
            selected={isMobileView}
            onClick={() => setScreenSize("mobile")}
          >
            <CellphoneIcon
              style={{ marginRight: 4 }}
              color={isMobileView ? colors.white : colors.teal.main}
            />
            Mobile
          </ToggleLink>
        </Toggle>
        <div style={{ display: "flex", maxWidth: "40%" }}>
          <Button
            className="change-theme-btn"
            variant="secondary"
            size="medium"
            onClick={() =>
              handleShowPopup(
                isLayoutUpdated
                  ? POPUP_TYPES.TEMPLATE_WARN
                  : POPUP_TYPES.SELECT_THEME
              )
            }
          >
            Change Template
          </Button>
          {(isLayoutUpdated || !entityTemplateId) && (
            <Button
                className="change-theme-btn"
                variant="secondary"
                size="medium"
              onClick={() => handleShowPopup(POPUP_TYPES.SAVE_TEMPLATE)}
              style={{ marginLeft: "16px" }}
            >
              Save as Template
            </Button>
          )}
        </div>
      </div>
    </Col>
  );
};

export default StorefrontHeader;
